import { render, staticRenderFns } from "./EipOrgSelector.vue?vue&type=template&id=28d2d6f0&"
import script from "./EipOrgSelector.vue?vue&type=script&lang=js&"
export * from "./EipOrgSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports